import { AppBar, Box, Stack } from '@mui/material';
import { Link } from '../../components';
import { MobileNavbar } from './MobileNavbar';
import LogoImage from '@peerless/ui-assets/logo/Logo.png';
import Image from 'next/image';
import {
  LanguageSelector,
  RegionCode,
  FlagRegionSelector,
  flagSelectorRegions,
} from '@peerless/ui-locale';
import { AccountButton } from './AccountButton';
import { HeaderNavBarQuickSearch } from './HeaderNavbarQuickSearch';
import { CartButton } from './CartButton';

export interface AppHeaderProps {
  desktop: React.ReactNode;
  mobile: React.ReactNode;
  region: RegionCode;
}

export const AppHeaderHeights = {
  xs: '4rem',
  md: '6rem',
};

const Logo = () => (
  <Box
    component={Image}
    src={LogoImage}
    alt="Peerless-AV"
    priority
    sx={{
      height: {
        xs: `calc(${AppHeaderHeights.xs} - 1.5rem)`,
        md: `calc(${AppHeaderHeights.md} - 3rem)`,
      },
      width: 'auto',
      mr: 3,
    }}
  />
);

export function AppHeader({ desktop, mobile, region }: AppHeaderProps) {
  return (
    <AppBar
      component="nav"
      role="menubar"
      elevation={4}
      sx={{
        px: 2,
        height: AppHeaderHeights,
        backgroundColor: 'gray.light',
        flexDirection: 'row',
        justifyContent: 'space-between',
        '& .MuiButton-outlinedSecondary': {
          borderColor: 'common.white',
          '&:hover': {
            borderColor: 'primary.main',
            backgroundColor: 'common.white',
            color: 'primary.main',
          },
        },
      }}
    >
      <Stack direction={'row'} alignItems={'center'}>
        <Link
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
          href="/"
        >
          <Logo />
        </Link>
        <Box sx={{ height: '100%', display: { xs: 'none', lg: 'flex' } }}>{desktop}</Box>
      </Stack>
      <Stack direction={'row'} alignItems={'center'} spacing={1}>
        <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
          <LanguageSelector />
        </Box>

        {flagSelectorRegions.includes(region) && (
          <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            <FlagRegionSelector region={region} />
          </Box>
        )}

        <HeaderNavBarQuickSearch />
        <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
          <AccountButton />
        </Box>
        <CartButton />

        <MobileNavbar>{mobile}</MobileNavbar>
      </Stack>
    </AppBar>
  );
}
